module.exports = __webpack_public_path__ + "img/logout.1d17b4e4.svg";